<div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header" style="background-color: whitesmoke; height: 20%">
      <a class="" rel="studentDetails" href="#" title="Student Details"> </a>
    </div>
  </div>

  <div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header">
      <a class="" rel="studentDetails" href="#" title="Student Details">
        <img
          class="responsive"
          style="width: 100%; height: auto"
          src="assets/images/header-1.png"
        />
      </a>
    </div>

    <section
      id="header"
      class="rounded"
      style="
        margin-top: 1%;
        background-color: white;
        text-align: center;
        text-emphasis-color: inherit;
      "
>
      <strong>HINDI ACADEMY</strong>
      <div class="container">
        <div class="row">
          <div
            class="col-md-12 col-xs-12 col-centered"
            style="align-items: center; text-decoration: underline"
          >
            <strong> PAYMENT DETAILS </strong>
          </div>
        </div>
      </div>
    </section>

    <div class="card" style="margin-top: 1%">

      <div class="card-body">
        <div *ngIf="!myDIV">
          <form [formGroup]="form" style="padding:20px 120px 0px 106px;" (ngSubmit)="Submit()">

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Customer Name </mat-label>
                <input
                type="text"
                maxlength="40"
                matInput
                placeholder="Customer Name"
                formControlName="customerName"
                autocomplete="off"
                required
              />
                <mat-error *ngIf="form.controls['customerName'].hasError('required')">Customer Name is required.</mat-error>
                <mat-error *ngIf="form.controls['customerName'].hasError('pattern')">Invalid Customer Name</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Address </mat-label>
                <input
                type="text"
                maxlength="100"
                matInput
                placeholder="Address"
                formControlName="address"
                autocomplete="off"
                required
              />
                <mat-error *ngIf="form.controls['address'].hasError('required')">Address is required.</mat-error>
                <mat-error *ngIf="form.controls['address'].hasError('pattern')">Invalid Address</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Mobile Number </mat-label>
                <input type="text" minlength="10" maxlength="10" matInput placeholder="Mobile Number" formControlName="mobileNo" autocomplete="off" required/>
                <mat-error *ngIf="form.controls['mobileNo'].hasError('required')">Mobile Number is required.</mat-error>
               <mat-error *ngIf="form.controls['mobileNo'].hasError('pattern')">Invalid Mobile Number</mat-error> 
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Email Id </mat-label>
                <input
                type="text"
                matInput
                maxlength="50"
                placeholder=" Email Id "
                formControlName="emailId"
                autocomplete="off"
                required/>
                <mat-error *ngIf="form.controls['emailId'].hasError('required')">Email Id is required.</mat-error>
                <mat-error *ngIf="form.controls['emailId'].hasError('pattern')">Invalid Email ID</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group" >
            <strong> <label for="class"> Book Name :  </label></strong><label for="class"> Indraprastha Bharti </label>           
            </div>

               <div class="form-group" style="width:100%">
                <mat-form-field  style="width:100%">
                  <mat-label>Select Subscription</mat-label>
                  <mat-select formControlName="subscription" panelClass="testClass" autocomplete="off" required (selectionChange)="onSubscriptionChange($event)">
                    <mat-option *ngFor="let subscription of subscriptionList" [value]="subscription">{{subscription}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.controls['subscription'].hasError('required')">Subscription is required.</mat-error>
                </mat-form-field>
                 </div>


                <!-- <div *ngIf="form.controls['totalAmount'].value">
              <div class="form-group" >
            <strong> <label for="class"> Total Amount : </label></strong>           
                <label for="class"> {{fetchFee}} Rs</label>

          </div> -->

          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Total Amount</mat-label>
              <input type="number" matInput maxlength="50" placeholder="Total Amount" formControlName="totalAmount" [readonly]="true" required/>
            </mat-form-field>
            {{totalAmount}}           
          </div> 


          <div class="form-group">
            <mat-form-field style="width:100%">
              <mat-label>Enter Remarks </mat-label>
              <input
              type="text"
              maxlength="100"
              matInput
              placeholder="Remarks"
              formControlName="remarks"
              autocomplete="off"
            />
              <!-- <mat-error *ngIf="form.controls['remarks'].hasError('required')">Student Name is required.</mat-error> -->
              <!-- <mat-error *ngIf="form.controls['remarks'].hasError('pattern')">Invalid Remarks</mat-error> -->
            </mat-form-field>
          </div>

          <div class="form-group">
              <label> Captcha <span>*</span></label>
              <input matInput  onpaste="return false;" onCopy="return false" onCut="return false" placeholder="Enter Captcha"
                 class="captchaFeild"  formControlName="captcha" autocomplete="off"
                minlength="6" maxlength="6"  onkeyup="this.value = this.value.toUpperCase();"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.captcha.errors }" style="border: 1px solid black;" required />
                <div *ngIf="submitted && f.captcha.errors " class="invalid-feedback">
                  <div *ngIf="f.captcha.errors.required">Captcha is required</div>
                  <div *ngIf="f.captcha.errors.incorrectcaptcha && (!f.captcha.errors.required)">Captcha is invalid </div>
                  <div *ngIf="f.captcha.errors.minlength && (!f.captcha.errors.required)">Captcha required of length {{f.captcha.errors.minlength.requiredLength}} and has length {{f.captcha.errors.minlength.actualLength}}  </div>
                </div>
             </div>
             <div id="capt">
                 <span onselectstart="return false" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false">{{initialCap}}</span>
                 <span style="float: right; cursor: pointer;">
                         <i class="material-icons" (click)="Cap()">refresh</i>
                 </span>
            </div>  

 

            <div class="form-group" style="
            display: flex;
            margin-top: 30px;
            justify-content: space-evenly;">
              <button
              #submitButton
              style="width: 129px;"
                class="btn btn-primary"
                

              >
                <span
                  *ngIf="loading"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                SUBMIT
              </button>
            </div>
            <div
              class="errBackButtonDiv"
              style="
                width: 129px !important;
                margin-top: 30px;
                margin-bottom: 20px;
              "
            >

            </div>
          </form>

        </div>
        <div>
          <form
            target="_top"
            #txnForm
            [formGroup]="tranxnForm"
            method="POST"
            action="{{ isgPay_url }}"
          >
            <input
              type="hidden"
              [value]="EncDataField"
              name="EncData"
              formControlName="EncData"
            />
            <input
              type="hidden"
              [value]="MerchantIdField"
              name="MerchantId"
              formControlName="MerchantId"
            />
            <input
              type="hidden"
              [value]="BankIdField"
              name="BankId"
              formControlName="BankId"
            />
            <input
              type="hidden"
              [value]="TerminalIdField"
              name="TerminalId"
              formControlName="TerminalId"
            />
            <input
              type="hidden"
              [value]="VersionField"
              name="Version"
              formControlName="Version"
            />
            <input
              type="hidden"
              [value]="TransactionId"
              name="OrderId"
              formControlName="TransactionId"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
